export default {
    name: 'v5-icon-arrow-up-fill',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M256.32 640l256-256 256 256z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
